module.exports = __webpack_public_path__ + "img/step05d__stand_power_bottom_cross.523c4aa9.png";